import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth, convertDate } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import DanhSachQuyKhacApi from "service/DanhSachQuyKhacApi";

const NhapRutQuy = ({ onClose, loadDanhSachQuyKhac, title, data }) => {
  const [Value, setValue] = useState(data?.Value ? Math.abs(data.Value) : 0);
  const [date, setDate] = useState(
    data?.Time ? convertDate(data.Time) : new Date()
  );
  const [user] = useState(data?.UserName ?? "");
  const [Note, setNote] = useState(data?.Note ?? "");
  const [saving, setSaving] = useState(false); //  trạng thái loading khi lưu
  const ValueInputRef = useRef(null);
  const handleKeyDown = (event) => {
    if (event.key === "Escape") onClose();
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);
  const onSaveNhapRutQuy = async (data) => {
    let success = "";
    let error = "";
    try {
      const res = await DanhSachQuyKhacApi.addorupdate(data);
      if (data.ThuChiId !== 0) {
        success = "Sửa quỹ thành công";
        onClose();
      } else {
        if (data.Status == -1) {
          if (data.Type === 51) {
            success = "Nhập quỹ thành công. Vui lòng chờ duyệt.";
            onClose();
          } else {
            success = "Rút quỹ thành công. Vui lòng chờ duyệt.";
            onClose();
          }
        } else {
          if (data.Type === 51) {
            success = "Nhập quỹ thành công";
            onClose();
          } else {
            success = "Rút quỹ thành công";
            onClose();
          }
        }
      }
      pushNotification(success, "success", "TOP_CENTER", 1000);
      loadDanhSachQuyKhac();
    } catch (err) {
      console.error("Lỗi:", err);
      if (data.ThuChiId !== 0) {
        error = "Sửa quỹ thất bại";
      } else {
        if (data.Type === 51) error = "Nhập quỹ thất bại!";
        else error = "Rút quỹ thất bại!";
      }
      pushNotification(error, "error", "TOP_CENTER", 1000);
    }
  };
  const handleSave = async () => {
    const numericValue = Number(Value.toString().replace(/,/g, ""));
    if (!numericValue || isNaN(numericValue) || numericValue <= 0) {
      pushNotification(
        "Vui lòng nhập số tiền hợp lệ.",
        "error",
        "TOP_CENTER",
        1000
      );
      if (ValueInputRef.current) ValueInputRef.current.focus();
      return;
    }

    try {
      setSaving(true);
      const payload = {
        ThuChiId: data?.ThuChiId ?? 0,
        Type: data?.Type,
        Name:
          data?.Type === 51
            ? "Nhập quỹ từ ngân hàng"
            : data?.Type === 52
            ? "Rút quỹ"
            : "Chuyển quỹ ngân hàng",
        Time: formatDayMonth(date),
        Value:
          data?.Type === 51 ? Math.abs(numericValue) : -Math.abs(numericValue),
        Note: Note ?? "",
        UserName: user,
        AdminApprove: data?.AdminApprove ?? 0,
        Status: data?.Status ?? -1,
      };
      await onSaveNhapRutQuy(payload);
    } catch (err) {
      console.error("Lỗi khi lưu:", err);
      pushNotification(
        "Có lỗi xảy ra khi lưu. Vui lòng thử lại.",
        "error",
        "TOP_CENTER",
        1000
      );
    } finally {
      setSaving(false);
    }
  };
  const handleValueChange = (e) => {
    let rawValue = e.target.value.replace(/\D/g, "");

    if (rawValue === "") {
      setValue("");
      return;
    }

    const formatted = Number(rawValue).toLocaleString("en-US");
    setValue(formatted);
  };

  return (
    <Modal
      show={true}
      size="md"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title">
          <span className="btn-icon-right">
            <i className="fas fa-funnel-dollar"></i>
          </span>{" "}
          {title}
        </h4>
        <button type="button" className="close-popup-new" onClick={onClose}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ overflowY: "visible" }}>
        <div className="form-group">
          <label htmlFor="Time" className="font-color-default font-bold">
            Ngày giao dịch
          </label>
          <DateTimePicker
            id="Time"
            value={date}
            onChange={setDate}
            placeholder="Ngày giao dịch"
            name="Time"
            className="form-control input-sm"
          />
        </div>
        <div className="form-group">
          <label htmlFor="user" className="font-color-default font-bold">
            Người giao dịch
          </label>
          <input
            type="text"
            id="user"
            disabled
            className="form-control input-sm"
            value={user}
          />
        </div>
        <div className="form-group">
          <label htmlFor="Value" className="font-color-default font-bold">
            Số tiền <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            id="Value"
            className="form-control input-sm"
            placeholder="Nhập số tiền"
            value={Value}
            onChange={handleValueChange}
            ref={ValueInputRef}
          />
        </div>
        <div className="form-group">
          <label htmlFor="Note" className="font-color-default font-bold">
            Ghi chú
          </label>
          <textarea
            id="Note"
            className="form-control1 input-sm"
            placeholder="Nhập mô tả"
            value={Note}
            onChange={(e) => setNote(e.target.value)}
            rows={3}
            style={{
              minHeight: "80px",
              width: "100%",
            }}
          ></textarea>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-new-main btn-closenew"
          onClick={onClose}
          disabled={saving}
        >
          <i className="mdi mdi-close"></i>&nbsp; Đóng
        </button>
        <button
          className="btn "
          onClick={handleSave}
          disabled={saving}
          style={{
            background: "#056569",
            color: "white",
            borderRadius: "6px",
            fontSize: "15px",
            textTransform: "none",
          }}
        >
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm"></span>&nbsp;
              Đang lưu...
            </>
          ) : (
            <>
              <i className="mdi mdi-content-save"></i>&nbsp; Lưu
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default NhapRutQuy;
